import React from "react";
import { NavLink } from "react-router-dom";
import { GsdStandaloneModuleSubNav, useI18n } from "@/coquille-bridge";

/** Convertit items BT-020 vers tabs coquille standalone. */
export function mapShotokanItemsToTabs(items) {
  return items.map((item) => ({
    id: item.testId,
    segment: item.segment ?? "",
    labelFr: item.labelFr,
    labelEn: item.labelEn,
    testId: item.testId,
    status: "active",
  }));
}

export function renderShotokanNavLink(tab, { className, children, href, disabled }) {
  if (disabled) {
    return (
      <span key={tab.id} className={className} aria-disabled="true" data-testid={tab.testId}>
        {children}
      </span>
    );
  }
  const segment = tab.segment ?? "";
  return (
    <NavLink
      key={tab.id}
      to={href}
      end={!segment}
      className={({ isActive }) =>
        `${className}${isActive ? " gsd-standalone-module-subnav__link--active" : ""}`
      }
      data-testid={tab.testId}
    >
      {children}
    </NavLink>
  );
}

/**
 * Sous-navigation Shotokan — consomme GsdStandaloneModuleSubNav (coquille BT-021).
 */
export function ShotokanBlackDragonSubNav({ basePath, items, testId = "shotokan-black-dragon-subnav" }) {
  const { lang } = useI18n();
  const locale = lang === "en" ? "en" : "fr";

  return (
    <GsdStandaloneModuleSubNav
      basePath={basePath}
      tabs={mapShotokanItemsToTabs(items)}
      lang={locale}
      testId={testId}
      ariaLabelFr="Module Shotokan Black Dragon"
      ariaLabelEn="Shotokan Black Dragon module"
      renderTabLink={renderShotokanNavLink}
    />
  );
}
